import type { EmailContactCreatedFromEnum } from '@gql/graphql';
import type { SelectOption } from '../DropdownSelectSearch';

export interface DogBreedInterestBannerData {
  breedOptions: SelectOption<string>[];
  isSubmitting: boolean;
}

export interface DogBreedInterestBannerProps extends DogBreedInterestBannerData {}
export interface BreedInterestFormValues {
  dogBreedNames: string[];
  email: string;
  marketingEmailConsent: boolean;
  hasADog?: boolean;
  lookingFor?: 'puppy' | 'information';
  sensitivity?: string | null;
  createdFrom: EmailContactCreatedFromEnum;
}
